export type Handler<T = unknown> = (event: T) => void;

export interface Emitter<Events extends Record<PropertyKey, unknown>> {
    all: Map<keyof Events, Set<Handler<Events[keyof Events]>>>;
    on<Key extends keyof Events>(type: Key, handler: Handler<Events[Key]>): void;
    off<Key extends keyof Events>(type: Key, handler: Handler<Events[Key]>): void;
    emit<Key extends keyof Events>(type: Key, event: Events[Key]): void;
}

export default function mitt<Events extends Record<PropertyKey, unknown>>(): Emitter<Events> {
    const all = new Map<keyof Events, Set<Handler<Events[keyof Events]>>>();

    return {
        all,

        on<Key extends keyof Events>(type: Key, handler: Handler<Events[Key]>): void {
            const handlers = all.get(type) ?? new Set<Handler<Events[keyof Events]>>();
            handlers.add(handler as Handler<Events[keyof Events]>);
            all.set(type, handlers);
        },

        off<Key extends keyof Events>(type: Key, handler: Handler<Events[Key]>): void {
            all.get(type)?.delete(handler as Handler<Events[keyof Events]>);
        },

        emit<Key extends keyof Events>(type: Key, event: Events[Key]): void {
            const handlers = all.get(type);
            if (!handlers) return;
            handlers.forEach((handler) => handler(event));
        },
    };
}
